import { render, staticRenderFns } from "./bind_dialog.vue?vue&type=template&id=6a1ce2e8&scoped=true"
import script from "./bind_dialog.vue?vue&type=script&lang=js"
export * from "./bind_dialog.vue?vue&type=script&lang=js"
import style0 from "./bind_dialog.vue?vue&type=style&index=0&id=6a1ce2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ce2e8",
  null
  
)

export default component.exports